
  import {Component, Prop, Vue} from "vue-property-decorator";
  import AttachmentsView from "@/components/AttachmentsView/index.vue";
  import {AttachmentHostType} from "@/api/appService";

  @Component({
  name: "protocol-detail",
  components:{
    AttachmentsView
  }
})
export default class extends Vue {
  @Prop() item!: any;
  @Prop({ required: false, default: "协议详情" }) formTitle!: string;
  @Prop({ required: false, default: "rtl" }) direction!: string;

  show = false;

  private attachmentHostType: AttachmentHostType = AttachmentHostType.Protocol;

  private handleClose() {
    this.show = false;
  }


}
